module.exports = __webpack_public_path__ + "static/media/objetive-icon.4d076af1.svg";